import React from "react";
import { useNavigate } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import { OnlineOrderView } from "./OnlineOrderPage";

// Settings → Online Ordering (/online-ordering)
// Opens the ordering page for the logged-in merchant's store (customer_id in
// localStorage), with a back button to Settings and a shareable public link.
export default function OnlineOrderSettingsPage() {
  const navigate = useNavigate();
  const customerId = localStorage.getItem("customer_id");
  const goBack = () => navigate("/user-settings");

  if (!customerId) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 text-center">
        <ShoppingBag className="mb-3 h-10 w-10 text-gray-300" aria-hidden="true" />
        <p className="font-medium text-gray-900">No store selected</p>
        <p className="mt-1 text-sm text-gray-500">Log in as a merchant to open online ordering.</p>
        <button
          type="button"
          onClick={goBack}
          className="mt-5 rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
        >
          Back to settings
        </button>
      </div>
    );
  }

  return <OnlineOrderView customerId={customerId} onBack={goBack} showShareLink />;
}
